module.exports = __webpack_public_path__ + "static/media/builder-profile.3f1ef664.png";